import { Image } from './Image';

export class OptionLabel {
    name: string;
    code: string;
    images: Array<Image>;
}
